import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import zhTranslations from "./locales/zh.json";
import enTranslations from "./locales/en.json";
import thTranslations from "./locales/th.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      zh: {
        translation: zhTranslations,
      },
      en: {
        translation: enTranslations,
      },
      th: {
        translation: thTranslations,
      },
    },
    lng: "zh", // 明确设置默认语言
    fallbackLng: "zh",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
